import { getURLParameter } from "../../../../../shared/lib/html5-software-library/src/ranj/util/URLUtil";
import Config from "../../../../../shared/src/ranj/app/config/Config";
import SectionsRandomizer from "../util/SectionsRandomizer";
import SectionConfig from "./SectionConfig";

export default class GameConfig extends Config {

    constructor() {
        super();
    }

    setPropertiesFromObject(obj) {
        super.setPropertiesFromObject(obj);
        this._speedMaxIndex = Math.max.apply(null, this.getValue("speeds"));
        this._sectionLength = this.getValue("sectionLength");
        this._speedsAbsolute = this.getValue("speeds");
        this._speedMultiplier = this.getValue("speedMultiplier");

        if (getURLParameter("randomization") === "0") {
            console.log("GameConfig: Using fixed sections.");
            this._sections = this.getValue("level").sections.map(sectionObj => SectionConfig.fromObject(sectionObj));
        } else {
            console.log("GameConfig: Using random sections.");
            this._sections = SectionsRandomizer.generateSections(
                this.getValue("level.randomizedSections"),
                this.getValue("level.start"),
                this.getValue("level.finish")
            ).map(sectionObj => SectionConfig.fromObject(sectionObj));
        }

        this._laneCount = this.sections[0].lanes.length;
    }

    /**@type {Array<SectionConfig>} */
    get sections() {
        return this._sections;
    }

    /**@type {Number} */
    get speedMaxIndex() {
        return this._speedMaxIndex;
    }

    /**
     * @param {Number} speedIdx 
     * @returns {Number}
     */
    getAbsoluteSpeed(speedIdx) {
        //NB!: Relies on speed indices in this._speedsAbsolute being ordered ascending!
        return this._speedsAbsolute[speedIdx] * this._speedMultiplier;
    }

    /**
     * @param {Number} offset 
     * @returns {Object}
     */
    getRoadDataForPosition(offset) {
        const sectionCfg = this.getRoadSectionForPosition(offset);

        const rsl = this._sectionLength;
        const sectionProgress = offset % rsl;
        const speedMaxIndex = sectionCfg.speedMax;
        const laneMax = sectionCfg.fastestLaneIndex;
        const speedMaxAbsolute = this.getAbsoluteSpeed(speedMaxIndex);

        return {
            sectionIndex: this.sections.indexOf(sectionCfg),
            sectionProgress: sectionProgress,
            fastLane: laneMax,
            speedMaxIndex: speedMaxIndex,
            speedMax: speedMaxAbsolute,
            action: sectionCfg.action
        };
    }

    /**
     * @param {Number} offset 
     * @param {Number} laneIdx 
     * @returns {{color:string, shape:string, speedIndex:Number, speed:Number}}
     */
    getLaneDataForPosition(offset, laneIdx) {
        const sectionCfg = this.getRoadSectionForPosition(offset);
        const laneCfg = sectionCfg.getLane(laneIdx);
        return {
            color: laneCfg.color,
            shape: laneCfg.shape,
            speedIndex: laneCfg.speed,
            speed: this.getAbsoluteSpeed(laneCfg.speed)
        }
    }

    /**
     * @param {Number} offset 
     * @param {Number} laneIdx 
     * @returns {Number}
     */
    getSpeedForPosition(offset, laneIdx) {
        const sectionCfg = this.getRoadSectionForPosition(offset);
        const laneCfg = sectionCfg.getLane(laneIdx);
        const speedIdx = laneCfg.speed;
        return this.getAbsoluteSpeed(speedIdx);
    }

    /**
     * @param {Number} offset 
     * @returns {SectionConfig}
     */
    getRoadSectionForPosition(offset) {
        return this.sections[Math.floor(offset / this._sectionLength)];
    }

    /**@type {Number} */
    get laneCount() {
        return this._laneCount;
    }

    /**@type {Number} */
    get roadLength() {
        if (!this._roadLength) {
            const sections = this.sections;
            //Convention: count sections until section with action 'finish'
            let i = 0
            for (; i < sections.length; i++) {
                if (sections[i].action == "finish") {
                    break;
                }
            }
            this._roadLength = this._sectionLength * i;
        }
        return this._roadLength;
    }

    /**
     * @param {string} id 
     * @returns {string}
     */
    getLaneTileSkin(id) {
        return this.getValue("laneTileSkins")[id];
    }

}